import { ServerError } from "ts-packages/igfd-ui/src/components/Error-Pages/500/ServerError";

import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * Route-level error fallback, used via react-router's `ErrorBoundary` route
 * property. The router catches render errors in the route's subtree, renders
 * this page in place of the route element, and clears the error state on the
 * next navigation.
 */
export const RouteErrorPage = () => {
  const navigate = useNavigate();

  return (
    <ServerError
      goBack={() => navigate(-1)}
      // navigate(0) performs a full page reload.
      refresh={() => navigate(0)}
    />
  );
};
